import { BooleanClaim } from 'supertokens-web-js/recipe/session';

// used to assert the auth is from a passwordless authentication.
export const PasswordlessClaim = new BooleanClaim({
  id: 'passwordless',
  // eslint-disable-next-line
  refresh: async(): Promise<void> => {},
});
